module.exports = __webpack_public_path__ + "img/piyao_5.9c4d875c.png";